import { createSlice } from '@reduxjs/toolkit';

const reducerName = 'atsJobDetailsDashboardData';
const initialState = {
  activities: {
    currentTab: 'overdue',
    sort: {
      id: 'time_in_stage',
      label: 'Time In stage (Longest to shortest)',
      element: 'time_in_stage',
      order: 'desc',
    },
    metrics: {
      data: {
        overdue: 0,
        needs_scheduling: 0,
        needs_decision: 0,
        needs_offer: 0,
        needs_action: 0,
      },
      isLoading: false,
    },
    overdue: { data: [], meta: {}, isLoading: false },
    needs_scheduling: { data: [], meta: {}, isLoading: false },
    needs_action: { data: [], meta: {}, isLoading: false },
    needs_decision: { data: [], meta: {}, isLoading: false },
    needs_offer: { data: [], meta: {}, isLoading: false },
  },
};

const { reducer, actions: atsJobDetailsDashboardActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    setActivitiesMetrics: (state, { payload }) => {
      const { counts } = payload ?? {};
      const {
        overdue,
        needs_scheduling,
        needs_action,
        needs_decision,
        needs_offer,
      } = counts;
      state.activities.metrics.data.overdue = overdue || 0;
      state.activities.metrics.data.needs_scheduling = needs_scheduling || 0;
      state.activities.metrics.data.needs_action = needs_action || 0;
      state.activities.metrics.data.needs_decision = needs_decision || 0;
      state.activities.metrics.data.needs_offer = needs_offer || 0;
      state.activities.metrics.isLoading = false;
    },

    setActivitiesTab: (state, { payload }) => {
      state.activities.currentTab = payload;
    },

    setActivitiesLoading: (state) => {
      state.activities.metrics.isLoading = true;
      state.activities[state.activities.currentTab].isLoading = true;
    },

    // `tab` is the tab that asked: a slow response landing after the user
    // moved on must fill its own tab, not the one now shown (which also left
    // the asking tab loading for good, hiding every count behind skeletons).
    setActivities: (state, { payload }) => {
      const {
        data = [],
        meta = {},
        tab = state.activities.currentTab,
      } = payload ?? {};
      state.activities[tab].data = data;
      state.activities[tab].meta = meta;
      state.activities[tab].isLoading = false;
    },

    applyActivitiesFilter: (state, { payload }) => {
      const { key, value } = payload;
      state.activities.filters[key] = value;
    },

    applyActivitiesSort: (state, { payload }) => {
      state.activities.sort = payload;
    },
  },
});

export { atsJobDetailsDashboardActions };
export default reducer;
